import '@/styles/InputStyles.scss';
import { debounce } from "debounce";

export default {
    data() {
        return {
            externallychanged: false,
            hovered: false,
        };
    },

    methods: {
        setHoverBool(bool) {
            this.hovered = bool;
            return bool;
        },

        customEditKeyPress(k) {
            if (k.key == "Enter") {
                k.target.blur();
            }
        },

        editKeyPress(k) {
            if (k.code == "NumpadEnter") {
                k.target.blur();
            }
        },

        editKeyDown(eventArgs) {
            if (eventArgs.key == "Escape") {
                //this.newValue = this.value;
                if (!this.externaledit) {
                    this.externallychanged = false;
                }
                eventArgs.target.blur();
            }
        },

        blurInput() {
            this.edit = false;
            if (!this.SameValue(this.newValue, this.value) && !this.error) {
                this.$emit("input", this.newValue);
                this.$emit("change", this.newValue);
            }
            if (!this.externaledit) {
                this.externallychanged = false;
            }
            this.$emit("FocusState", false);
            this.$emit("blur");
        },

        setEdit() {
            if (!this.disabled && !this.loading) {
                this.edit = true;
                this.$emit("FocusState", true);
            }
        },

        debounceInput: debounce(function (e) {
            //console.log('debounced' + e);
            this.$emit("DebouncedInput", e);
        }, 700)
    },

    computed: {
        IsEmpty() {
            if (this.newValue === null || this.newValue === undefined || this.newValue === "" || (Array.isArray(this.newValue) && !this.newValue.length)) {
                return true;
            }
            else {
                return false;
            }
        },

        IsRequired() {
            return (this.rules && this.rules.some(x => x.name == 'requiredRule'));
        },

        displayValue() {
            return this.externaledit ? this.newValue : this.value;
        },

        placeholderText() {
            return this.placeholder ? this.placeholder : '';
        },

        labelText() {
            if (this.label != undefined) {
                return this.IsRequired ? (this.label + '*') : this.label;
            }
            else {
                return undefined;
            }
        },

        modelValue: {
            get() {
                return (this.edit) ? this.newValue : this.displayValue;
            },
            set(val) {

                this.newValue = val;
            },
        },

        BackgroundColor() {
            /*if (this.disabled) {
                return "#fcfcfc";
            }
            else if (this.loading) {
                return "#faf8ff";
            }
            else*/  if (this.backgroundcolor) {
                return this.backgroundcolor;
            } else if (this.edit) {
                return "#f7faff";
            } else {
                return "";
            }
        },

        BorderClass() {
            if (!this.externaledit && (!this.hovered || this.IsDisabled) && (this.IsDisabled || !this.edit)) {
                return "noeditborder";
            } else {
                return "";
            }
        },

        InputColor() {
            if (this.IsEmpty) {
                return 'disabled';
            } else if (this.color) {
                return this.color;
            } else {
                return "";
            }
        },

        InputColorClass() {
            return this.InputColor + '--inputtext';
        },

        BlurrClass() {
            return this.loading ? 'blurredinput' : ''
        },

        IsDisabled() {
            return this.disabled || this.loading
        },

        CompactClass() {
            return this.singleline ? 'compact' : '';
        },
    },

    watch: {
        value: function () {
            if (this.allowexternaloverride || (!this.externaledit && !this.edit)) {
                this.newValue = this.value;
            }
            else if (!this.SameValue(this.newValue, this.value)) {
                this.externallychanged = true;
            }
        },

        newValue: function () {
            if (!this.emitOnlyOnBlur) {
                if (!this.SameValue(this.newValue, this.value)) {
                    this.$emit("input", this.newValue);
                    this.debounceInput(this.newValue);
                }
            }
        },

        externaledit: function () {
            this.newValue = this.value;
            this.externallychanged = false
        }
    },
}
